import Icon from "@ant-design/icons";
import React from "react";

export default function FilterCheckIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 7C4.33579 7 4 7.33579 4 7.75C4 8.16421 4.33579 8.5 4.75 8.5H19.25C19.6642 8.5 20 8.16421 20 7.75C20 7.33579 19.6642 7 19.25 7H4.75ZM6.75 11C6.33579 11 6 11.3358 6 11.75C6 12.1642 6.33579 12.5 6.75 12.5H17.25C17.6642 12.5 18 12.1642 18 11.75C18 11.3358 17.6642 11 17.25 11H6.75ZM8 15.75C8 15.3358 8.33579 15 8.75 15H10.8818C10.5097 15.415 10.4067 15.994 10.5854 16.5H8.75C8.33579 16.5 8 16.1642 8 15.75ZM14.2863 16.2981L13.118 15H15.25C15.3358 15 15.4183 15.0144 15.4951 15.041L14.2863 16.2981ZM21.0406 12.5198C21.3277 12.2213 21.3184 11.7465 21.0198 11.4594C20.7213 11.1723 20.2465 11.1816 19.9594 11.4802L14.2682 17.399L12.5575 15.4983C12.2804 15.1904 11.8062 15.1654 11.4983 15.4425C11.1904 15.7196 11.1654 16.1938 11.4425 16.5017L13.6925 19.0017C13.8319 19.1566 14.0294 19.2465 14.2376 19.2499C14.4459 19.2533 14.6462 19.17 14.7906 19.0198L21.0406 12.5198Z"
        fill="currentColor"
      />
    </svg>
  );
};
